module.exports = __webpack_public_path__ + "static/img/brees-2008-slide-1.04f5c65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2008-slide-1.jpg
// module id = 6jSR
// module chunks = 1